import { gql } from '@apollo/client';

export const profileSearchQuery = gql`
  query profileSearchQuery($search: String, $page: Int, $limit: Int) {
    website {
      id
      profileSearch(search: $search, page: $page, limit: $limit) {
        meta {
          count
          page
          limit
        }
        profiles {
          id
          pseudo
          picture
          relation {
            id
            status
          }
          user {
            id
          }
        }
      }
    }
  }
`;
